import { render, staticRenderFns } from "./AddAdmin.vue?vue&type=template&id=13ad0a69&scoped=true&"
import script from "./AddAdmin.vue?vue&type=script&lang=ts&"
export * from "./AddAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./AddAdmin.vue?vue&type=style&index=0&id=13ad0a69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ad0a69",
  null
  
)

export default component.exports